import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: boolean =  false;

export const mobileSlice = createSlice({
  name: "mobile",
  initialState,
  reducers: {
    toggleMobile: (state) => {
      return state = !state;
    },
    setMobile: (state, action: PayloadAction<boolean>) => {
      return state = action.payload;
    },
  },
});

export const { toggleMobile, setMobile } = mobileSlice.actions;
export default mobileSlice.reducer;
